"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Can = exports.isFreeUser = exports.hasPermission = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const roles_1 = require("./roles");
const permission_1 = require("./rules/permission");
const hasPermission = (action, data, role, rules) => {
    if (role === roles_1.Role.ADMIN) {
        // Admin users should not see login and signup if they're logged in
        // This avoid flashing content when checking for guestOnly role
        return ![
            permission_1.Permission.Signup.View,
            permission_1.Permission.Login.View,
            permission_1.Permission.Subscription.Edit,
            permission_1.Permission.Zoo.ViewPartnerStatisticsLink,
        ].includes(action);
    }
    const permissions = rules[role];
    if (!permissions) {
        // role is not present in the rules
        return false;
    }
    const staticPermissions = permissions.static;
    if (staticPermissions && staticPermissions.includes(action)) {
        // static rule not provided for action
        return true;
    }
    const dynamicPermissions = permissions.dynamic;
    if (dynamicPermissions) {
        const permissionCondition = dynamicPermissions[action];
        if (!permissionCondition) {
            // dynamic rule not provided for action
            return false;
        }
        return permissionCondition(data);
    }
    return false;
};
exports.hasPermission = hasPermission;
const isFreeUser = (role, subscription) => {
    if ([roles_1.Role.ADMIN, roles_1.Role.PARTNER, roles_1.Role.HOST, roles_1.Role.MODERATOR].includes(role)) {
        return false;
    }
    return !(subscription === null || subscription === void 0 ? void 0 : subscription.active);
};
exports.isFreeUser = isFreeUser;
const Can = (hasPermission) => ({ perform, yes = () => null, no = () => null, data }) => hasPermission(perform, data) ? yes() : no();
exports.Can = Can;
